var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBullet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 120,
    viewBox: "0 0 285 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_15187)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 60,
    height: 40,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 60,
    height: 40,
    fill: "#4B2CE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2188 92.2656V106.406H26.4688V92.2656H28.2188ZM16.9219 98.2812C16.9141 95.2344 18.4688 93.2969 20.6094 93.2969C22.7266 93.2969 24.2891 95.2344 24.2969 98.2812C24.2891 101.352 22.7266 103.281 20.6094 103.281C18.4688 103.281 16.9141 101.352 16.9219 98.2812ZM18.5938 98.2812C18.5938 100.453 19.4141 101.711 20.6094 101.719C21.7969 101.711 22.6094 100.453 22.6094 98.2812C22.6094 96.125 21.7969 94.8594 20.6094 94.8594C19.4141 94.8594 18.5938 96.125 18.5938 98.2812ZM35.3594 96.2812C35.3516 98.4609 36.6641 100.945 38.8906 101.984L37.9219 103.359C36.3281 102.609 35.1484 101.094 34.5156 99.3281C33.875 101.266 32.6406 102.922 31.0156 103.703L30 102.344C32.25 101.273 33.6172 98.6328 33.625 96.2812V95.0938H30.5469V93.6562H38.3125V95.0938H35.3594V96.2812ZM39.625 106.391V92.2656H41.3594V97.7656H43.5312V99.2188H41.3594V106.391H39.625Z",
    fill: "#E0E7FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_316_15187)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 80,
    width: 60,
    height: 40,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 80,
    width: 60,
    height: 40,
    fill: "#4B2CE8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_316_15187)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    transform: "translate(150 80)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 80,
    width: 60,
    height: 40,
    rx: 4,
    fill: "#4B2CE8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_316_15187)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225,
    width: 60,
    height: 120,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    width: 60,
    height: 120,
    fill: "#E0E7FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_316_15187)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    transform: "translate(225 80)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 80,
    width: 60,
    height: 40,
    rx: 4,
    fill: "#4B2CE8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.312 34.2812V44.9688H251.562V43.7344H248.797V42.5156H251.562V34.2812H253.312ZM241.406 40.625C244.008 40.6094 247.516 40.5859 250.516 40.2031L250.609 41.4531C249.445 41.6484 248.242 41.7734 247.047 41.8594V44.5781H245.312V41.9531C243.992 42.0078 242.734 42.0156 241.625 42.0156L241.406 40.625ZM242.484 37.2969C242.484 35.8047 243.922 34.7891 246.016 34.7969C248.07 34.7891 249.516 35.8047 249.531 37.2969C249.516 38.8125 248.07 39.7734 246.016 39.7812C243.922 39.7734 242.484 38.8125 242.484 37.2969ZM243.281 48.1094V43.9375H245.016V46.7031H253.641V48.1094H243.281ZM244.125 37.2969C244.125 38.0625 244.883 38.5078 246.016 38.5156C247.094 38.5078 247.867 38.0625 247.875 37.2969C247.867 36.5312 247.094 36.0703 246.016 36.0781C244.883 36.0703 244.125 36.5312 244.125 37.2969ZM266.625 34.9531V36.0469C266.633 37.1484 266.633 38.3984 266.281 40.0625H268.203V41.4688H255.297V40.0625H264.523C264.859 38.5312 264.891 37.375 264.891 36.3438H256.891V34.9531H266.625ZM256.844 48.2188V43.1094H266.609V48.2188H256.844ZM258.547 46.8125H264.891V44.4688H258.547V46.8125Z",
    fill: "#4B2CE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_15187"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 60,
    height: 40,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_316_15187"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 80,
    width: 60,
    height: 40,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_316_15187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white",
    transform: "translate(150 80)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_316_15187"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225,
    width: 60,
    height: 120,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_316_15187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white",
    transform: "translate(225 80)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullet);
export default __webpack_public_path__ + "static/media/bullet.ca4f6e77b5d0f4e492be88f2ee00da37.svg";
export { ForwardRef as ReactComponent };